export default __webpack_public_path__ + "img/b204ff66032c8763b873412c7a12d438.jpg";